<template>

  <div>

    <AppHeader id="header" />

    <AppSidebar id="sidebars" />
    <div class="wrapper d-flex flex-column  ">
      <div class="body flex-grow-1" style="border: 2px rgb(193, 193, 193) solid; background-color: white">
        <CContainer fluid>
          <router-view />
        </CContainer>
      </div>

    </div>
    <br>
    <br>
    <AppFooter />
    <!-- <div  id="footer" style="   z-index: 9;">

    </div> -->

  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
//s
export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar,
    CContainer,
  },
}
</script>

<style lang="scss">
.sidebar {
  --cui-sidebar-bg: rgb(0, 74, 173);
  --cui-sidebar-brand-bg: rgb(0 0 21 / 0%);


  height: 100vh;

}

.sidebar-toggler:hover {
  background-color: rgb(0 0 21 / 0%);
}
</style>
